import { useMutation } from 'react-query';

import { mutations } from '~/constants/mutationKeys';
import { VinovestNetworkingHelper } from '~/helpers/VinovestNetworkingHelper';
import { useManagedPortfolioQuery } from '~/hooks/queries/portfolios/managed/useManagedPortfolioQuery';
import { PutAllocationClassificationPayload } from '~/networking/api/managed/requests/portfolio/putAllocationClassification';

import { useAuthentication } from '../useAuthentication';

export const useUpdateAllocationClassification = () => {
    const { isAuthenticated } = useAuthentication(true);
    const { refetch } = useManagedPortfolioQuery();
    return useMutation(
        [mutations.UpdatePortfolioAllocationClassification],
        async (updater: { payload: PutAllocationClassificationPayload; portfolioID: string }) => {
            if (!isAuthenticated) {
                return false;
            }

            const { managed } = VinovestNetworkingHelper.getClient();

            const result = await managed.putAllocationClassification(updater);
            if (result.ok) {
                return true;
            }
            return false;
        },
        {
            onSuccess: () => {
                refetch();
            }
        }
    );
};
